export class ChartColorUtils {
    // HIGH CONTRAST PROFESSIONAL PALETTE
    private static readonly palette = [
        '#e6194b',
        '#3cb44b',
        '#ffe119',
        '#4363d8',
        '#f58231',
        '#911eb4',
        '#46f0f0',
        '#f032e6',
        '#bcf60c',
        '#fabebe',
        '#008080',
        '#e6beff',
        '#9a6324',
        '#fffac8',
        '#800000',
        '#aaffc3',
        '#808000',
        '#ffd8b1',
        '#000075',
        '#808080',
    ];

    // SHARED CACHE
    private static colorMap: Record<string, string> = {};

    private static nextIndex = 0;

    static getColor(key: string): string {
        if (!this.colorMap[key]) {
            this.colorMap[key] =
                this.palette[this.nextIndex % this.palette.length];

            this.nextIndex++;
        }

        return this.colorMap[key];
    }

    static reset() {
        this.colorMap = {};

        this.nextIndex = 0;
    }
}
